import React from 'react';
import Select, { components } from "react-select";
import { ErrorMsg } from "../error-message";
import { Controller, useFormContext } from 'react-hook-form';

export default function Selectable({
    id,
    name,
    placeholder,
    options,
    getSelected = () => { },
}) {
    const IndicatorSeparator = () => null
    const { register, control, formState: { errors } } = useFormContext()
    const NoOptionsMessage = (props) => (
        <components.NoOptionsMessage {...props}>
            <span className="custom-css-class">No hay opciones</span>
        </components.NoOptionsMessage>
    )
    const DownChevron = () => null
    const DropdownIndicator = () => null

    const colourStyles = {
        control: (styles, state) => ({
            ...styles,
            borderColor: state.isFocused ? '#fff' : '#bbb',
            padding: "5px 0",
            borderRadius: "3px"
        }),
        option: (styles, { isSelected }) => ({
            ...styles,
            color: isSelected ? '#fff' : '#444'
        })
    }

    return <div>

        <Controller
            control={control}
            render={({ field: { onChange, value, name, ref } }) => (
                <Select
                    ref={ref}
                    id={id}
                    value={options.find((c) => c.value === value) || null}
                    placeholder={placeholder}
                    components={{
                        DropdownIndicator,
                        DownChevron,
                        IndicatorSeparator,
                        NoOptionsMessage
                    }}
                    options={options}
                    onChange={(selectedOption) => {
                        onChange(selectedOption.value)
                        getSelected(selectedOption)
                    }}
                    styles={colourStyles}
                />
            )}
            name={name}
        />
        <ErrorMsg errors={errors} name={name} />
    </div>

}